import { type LoaderFunction } from 'react-router-dom';

export function searchParamsLoader(): ReturnType<LoaderFunction> {
	// No changes needed, proceed with rendering
	// Account ID injection is now handled by components with React context access
	return null;
}
